import { defineComponent as _defineComponent } from 'vue'
import { useIsDesktop } from "@/features/useIsDesktop";

  const MIN_DESKTOP_WIDTH = 992;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandingFormDetails',
  props: {
    title: {},
    features: {},
    isSignUpView: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(MIN_DESKTOP_WIDTH);

  const props = __props;

const __returned__ = { MIN_DESKTOP_WIDTH, isDesktop, props, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})